import Icon from '../components/Icon.vue'

Icon.register({
  'euro-sign': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M310.7 413.8l8.8 44.5c1.2 6.2-2.6 12.4-8.8 14-12.5 3.2-34.8 7.8-61.1 7.8-104.4 0-182.5-65.3-207.5-155.6h-30.1c-6.6 0-12-5.4-12-12v-28.4c0-6.6 5.4-12 12-12h21.4c-1-13-0.8-28.6 0.2-42.2h-21.6c-6.6 0-12-5.4-12-12v-29.8c0-6.6 5.4-12 12-12h33.1c29-83.7 107.4-144 204.6-144 21.1 0 40.6 2.9 52.7 5.2 6.9 1.3 11.1 8.2 9.3 14.9l-12 44.4c-1.7 6.1-7.8 9.9-14 8.6-9.3-1.9-23.4-4.1-37.9-4.1-54.9 0-97 30-117.6 75h138.3c7.7 0 13.4 7.1 11.7 14.6l-6.5 29.8c-1.1 5.2-6.4 9.4-11.7 9.4v0h-146.6c-1.6 14-1.3 27.9-0.1 42.2h134.2c7.7 0 13.4 7.1 11.7 14.6l-6.4 28.4c-1.2 5.2-6.4 9.4-11.7 9.4h-113.7c19.5 50.7 64.7 85.4 121.5 85.4 18 0 34.7-3 45.4-5.4 6.6-1.5 13.1 2.7 14.4 9.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/euro-sign.js
// module id = 1307
// module chunks = 0